import React from 'react';
import PropTypes from 'prop-types';
import Stars from '../stars/Stars';

const ListingDetails = ({ location, guests, reviewStars, reviewCount, reviews, hideLocation }) => (
  <div className="details-wrapper">
    { hideLocation ?
      null :
      <div className="location">{ location }</div>
    }
    { guests &&
        <div className="attendee-wrapper"><i className="ico ico-md icon-attendees" />{ guests }</div>
    }

    { reviews &&
        <Stars reviewStars={ reviewStars } reviewCount={ reviewCount } />
    }
  </div>
);

export default ListingDetails
